import Typography from "@mui/material/Typography";
import { Theme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

interface SummaryItemProps {
  label: string;
  value: string | null;
}

export function SummaryItem({ label, value }: SummaryItemProps) {
  const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up("md"));

  return (
    <>
      <Typography
        variant="subtitle1"
        color={(theme) => theme.colors.grey1}
        mb={0.5}>
        {label}
      </Typography>
      <Typography
        variant={isDesktop ? "body1" : "body2"}
        sx={{ wordBreak: "break-word" }}>
        {value}
      </Typography>
    </>
  );
}
